
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/content/[slug]",
      function () {
        return require("private-next-pages/en/content/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/content/[slug]"])
      });
    }
  